class UpsellController extends HTMLElement {
  constructor() {
    super();

    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      this.handleFetchRecommended.bind(this)
    );
    this.limit = 4;
    this.apiUrl = 'recommendations/products.json';
    this.cartId = null;
    this.recommendationApi = null;
    this.sectionId = null;
    this.productId = null;
    this.intent = 'complementary';
    this.productCard = null;
    this.errorMessage = null;
    this.abortController = null;
  }

  connectedCallback() {
    this.sectionId = this.getAttribute('data-id');
    this.productId = this.getAttribute('data-product-id');
    this.intent = this.getAttribute('data-intent');
    this.errorMessage = this.getAttribute('data-error-message');
    this.recommendationApi = `${window.shopUrl}/${this.apiUrl}?&product_id=${this.productId}&intent=${this.intent}&limit=${this.limit}`;

    if (!this.productId) {
      console.warn('Missing Product Id on Upsell. Unable to fetch data');
    }

    // if (this.classList.contains('loading')) {
    //   this.classList.remove('loading');
    // }

    window.addEventListener('load', () => {
      this.handleFetchRecommended(this);
    });

    this.cartUpdateUnsubscriber = subscribe(
      PUB_SUB_EVENTS.cartUpdate,
      this.handleFetchRecommended.bind(this)
    );
  }

  // cleanups
  disconnectedCallback() {
    if (this.cartUpdateUnsubscriber) {
      this.cartUpdateUnsubscriber();
    }

    window.removeEventListener('load', () => {
      this.handleFetchRecommended(this);
    });
  }

  handleFetchRecommended() {
    fetch(this.recommendationApi)
      .then((response) => response.json())
      .then((data) => {
        if (data.status === 422 || data.status) {
          this.handleErrorState(data);
        }

        if (data.products) {
          this.handleIterateData(data.products);
        }

        if (data.products.length === 0) {
          this.classList.add('hidden');
        }

        this.classList.remove('loading');
      })
      .catch((e) => {
        this.handleErrorState(e);
      });
  }

  handleIterateData(products) {
    const upsellWrapper = document.getElementById('upsell-wrapper');
    upsellWrapper.innerHTML = ''; // Clear first then append

    products.map((product) => {
      const upsellCard = new UpsellCard(product, this.errorMessage);
      const upsellCardCreated = upsellCard.create();

      upsellWrapper.appendChild(upsellCardCreated);
    });
  }

  handleRenderLoader() {
    const loaderWrapper = document.createElement('div');
    loaderWrapper.className =
      'absolute w-full h-full flex justify-center items-center top-0 left-0 hidden peer-aria-disabled:block';

    loaderWrapper.innerHTML = `<div class='absolute w-full h-full flex justify-center items-center'><svg xmlns="http://www.w3.org/2000/svg" class="w-1.5" viewBox="0 0 66 66"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg></div>`;

    return loaderWrapper;
  }

  handleErrorState(e) {
    this.classList.remove('loading');
    this.classList.add('error');

    console.error('Error Fetching Recommended Data: ', e);
  }
}

customElements.define('upsell-controller', UpsellController);
